import { ReactElement } from 'react';
import Image from 'components/UI/Image';
import RichText from 'components/UI/Richtext';
import { IComponentProcessStepsFields, IFragmentImageWithCopy } from 'types/contentful';

export default function ProcessSteps({
  heading,
  copy,
  stepsList,
  copyAlignment = 'center',
}: IComponentProcessStepsFields): ReactElement {
  console.log(copyAlignment);

  return (
    <div className="mx-auto ecp-my text-primary-actual pb-10 md:pb-20 px-site-component">
      <div className="flex flex-col lg:flex-row justify-center gap-8 lg:gap-6">
        {heading && (
          <div className="w-full lg:w-1/2">
            <div className="bordered-heading-richtext text-left text-primary-actual md:mb-8 font-light">
              <RichText
                document={heading}
                classNames="text-new-34 md:text-4xl lg:leading-new-43 max-w-none richtext-nomargin-headings richtext-font-inherit"
                noEmpty={true}
              />
            </div>
          </div>
        )}
        {copy && (
          <div className="w-full lg:w-1/2 lg:pl-6">
            <RichText document={copy} classNames={`text-lg text-primary-actual text-left`} />
          </div>
        )}
      </div>

      {(heading || copy) && <div className="block mb-6 lg:mb-8"></div>}

      {/* Steps List */}
      {stepsList && stepsList.length > 0 && (
        <div className="space-y-8">
          {stepsList.map((step: IFragmentImageWithCopy) => {
            return (
              <div key={step.sys.id} className="bg-muted">
                {/* Step Content */}
                <div className="flex flex-col lg:flex-row justify-between gap-4 lg:gap-8 lg:items-center p-4 lg:py-8 lg:px-32 mx-auto">
                  <div className="order-2 lg:order-1">
                    {step.fields.heading && (
                      <h3 className="text-left text-xl md:text-2xl font-light">
                        {step.fields.heading}
                      </h3>
                    )}
                    {step.fields.copy && (
                      <div className="text-left">
                        <RichText
                          document={step.fields.copy}
                          classNames="text-md lg:text-lg bullet-aligned-indent"
                        />
                      </div>
                    )}
                  </div>
                  <div className="flex lg:justify-center lg:ml-auto order-1 lg:order-2">
                    {step.fields.image && (
                      <div className="w-32 md:w-56 rounded-full overflow-hidden flex-shrink-0">
                        <Image
                          image={step.fields.image}
                          query={`w=192&h=192&fit=fill`}
                          classNames="w-full h-full object-cover"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
